
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameElementSkinFactory from "../view/GameElementSkinFactory";

export default class InitAccuracyGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel, levelAssets) {
        super();

        this.execute = function(callback, progressCallback) {
            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            gameModel.initialize();

            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;

                const n = parseInt(getURLParameter("create"));
                if (!isNaN(n)) {
                    const elementFactory = new GameElementSkinFactory(gameConfig, levelAssets);
                    this.createPuzzles(gameConfig, elementFactory, n);
                }
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);
    }


    createPuzzles(gameConfig, elementFactory, n = 30, matches = [5, 6, 7], poolSize = 25) {
        const firstTarget = gameConfig.getValue("tutorial").puzzle.target;

        const locations = gameConfig.getValue("locations");
        //
        const itemPool = [];
        const itemCount = gameConfig.getValue("items").length;
        for (let i = 0; i < itemCount; i++) itemPool.push(i);

        const puzzles = [];
        for (let i = 0; i < n; i++) {
            //rotate through locations
            const locationIndex = i % locations.length;
            const location = locations[locationIndex];
            const locationSkin = elementFactory.getLocation(locationIndex);
            locationSkin.gotoAndStop(0);
            const slotCount = locationSkin.children.filter(child=>child.name.indexOf("slot")==0).length;

            const matchCount = pick(matches);
            const pool = ArrayUtil.shuffle(itemPool.slice(0)).slice(0, poolSize);
            const match = i == 0 ? firstTarget : pool.pop();
            const items = [];
            for (let j = 0; j < matchCount; j++) {
                items.push(match);
            }
            for (let j = 0; j < slotCount - matchCount; j++) {
                items.push(pick(pool));                
            }
            ArrayUtil.shuffle(items);
            puzzles.push({
                location: locations.indexOf(location),
                target: match,
                count: matchCount,
                items: items
            });
        }
        console.log(JSON.stringify(puzzles));
        gameConfig._data.puzzles = puzzles;
    }

}

const pick = function(pool) {
    return pool[Math.floor(Math.random() * pool.length)];
}

const ArrayUtil = {};
ArrayUtil.shuffle = function(a) {
    let j, x, i;
    for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}